module.exports = __webpack_public_path__ + "static/media/MoneyCart2.26e964ab.png";